import css from '../assets/css.png';
import figma from '../assets/figma.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import react from '../assets/react.png';
import sass from '../assets/sass.png';
import illustrator from '../assets/illustrator.png';
import photoshop from '../assets/photoshop.png';
import indesign from '../assets/indesign.png';
import slack from '../assets/slack.png';

import about04 from '../assets/about04.png';
import target from '../assets/target.jpg';
import trophy from '../assets/trophy.jpg';
import puzzle from '../assets/puzzle.jpg';
import pentool from '../assets/pen_tool.jpg';
import dogCheck from '../assets/dogCheck.jpg';
import dogCheckWeb from '../assets/dogCheck_web.jpg';
import hairSalonTina from '../assets/hair_salon_tina.jpg';
import kinderGarten from '../assets/djecji_vrtic_rozica.jpg';
import sportClubSud from '../assets/Sport_club_sud.jpg';
import magazine from '../assets/magazine.jpg';
import octris from '../assets/octris.jpg';

import logo from '../assets/logo.png';


export default {
  css,
  figma,
  git,
  html,
  javascript,
  react,
  sass,
  about04,
  logo,
  illustrator,
  photoshop,
  indesign,
  slack,
  target,
  trophy,
  puzzle,
  pentool,
  dogCheck,
  hairSalonTina,
  kinderGarten,
  sportClubSud,
  dogCheckWeb,
  magazine,
  octris
};